import { Combo } from './combo.model';
import { PrestarContaInstrutor } from './prestar-conta-instrutor';
import { Turma } from './turma-model';
import { Conteudo } from './conteudo-model';

export class PrestarConta 
{
    public id : number;
    public id_turma : number;
    public id_conteudo : number;
    public prestacao_conta_instrutor: PrestarContaInstrutor[];

    public turma: Turma;
    public conteudo: Conteudo;

}


// WEBPACK FOOTER //
// ./src/app/entity/prestar-conta.ts